// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchMovie_wrapper__HAK7A","image":"SearchMovie_image__kOg4l","content":"SearchMovie_content__M44OG"};